import Section from "components/shared/Profile/Section";
import Property from "components/shared/Profile/Property";

const Profile = {
  Section,
  Property,
};

export default Profile;
